/**
 * ForBusinessHero — hero for /for-business. Like the shared VideoHero, it grows
 * with its content, so long translations or a narrow phone never spill into the next section.
 * Top padding clears the fixed, translucent Header (4rem bar + safe-area inset) with room to spare.
 * The video is decorative: hidden for reduced-motion users, who get the forest gradient instead.
 */

import type { ReactNode } from 'react';

export function ForBusinessHero({ videoSrc, children }: { videoSrc: string; children: ReactNode }) {
  return (
    <section className="relative isolate overflow-hidden bg-gradient-to-b from-brand-900 to-brand-700 min-h-[min(640px,88svh)] flex items-center pt-[calc(4rem+env(safe-area-inset-top,0px)+2rem)] pb-14 sm:pt-[calc(4rem+env(safe-area-inset-top,0px)+3.5rem)] sm:pb-20">
      <div className="absolute inset-0 -z-10" aria-hidden>
        <video autoPlay loop muted playsInline preload="metadata" className="h-full w-full object-cover motion-reduce:hidden">
          <source src={videoSrc} type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 to-black/40" />
      </div>
      {children}
    </section>
  );
}
